import React,{useState,useEffect,lazy} from 'react';
import axios from 'axios'
import { Button, message, Spin } from 'antd';
import { LoadingOutlined, PrinterOutlined } from '@ant-design/icons';
import moment from 'moment';
import {withGetScreen} from 'react-getscreen'


import { Bar } from 'react-chartjs-2';
import { primarycolor } from "./primarycolor";
import * as serverconfig from "./serverconn";


var CryptoJS = require("crypto-js");

const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

var bizuserid= ''
var sacco= ''
var token= ''


class TrackingGraph extends React.Component {

  state = {
    datarequested:true,
    tracking_hubs_report:[],
    isMobile: window.innerWidth <= 768
  };

  chartRef = React.createRef();

  // Fetch tracking data for standalone use
  fetchTrackingData = async () => {
    try {
      const form_data = new FormData();
      form_data.append('dateone', moment().subtract(30, 'days').format('YYYY-MM-DD'));
      form_data.append('datetwo', moment().format('YYYY-MM-DD'));
      form_data.append('region', '');
      form_data.append('district', '');

      const response = await axios.post(`${serverconfig.backendserverurl}/customqueries/get_hubs_visited_statistics`, form_data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      });

      this.setState({ 
        tracking_hubs_report: response.data,
        datarequested: false 
      });
    } catch (error) {
      console.error('Error fetching tracking data:', error);
      this.setState({ datarequested: false });
    }
  };


  // Print functionality
  printChart = () => {
    try {
      if (this.chartRef.current) {
        let canvas = null;
        
        // Try multiple ways to access the canvas (Chart.js v2 compatibility)
        if (this.chartRef.current.chartInstance && this.chartRef.current.chartInstance.canvas) {
          canvas = this.chartRef.current.chartInstance.canvas;
        } else if (this.chartRef.current.chart && this.chartRef.current.chart.canvas) {
          canvas = this.chartRef.current.chart.canvas;
        } else if (this.chartRef.current.canvas) {
          canvas = this.chartRef.current.canvas;
        } else {
          // Try to find canvas element directly
          const chartContainer = this.chartRef.current;
          if (chartContainer && chartContainer.querySelector) {
            canvas = chartContainer.querySelector('canvas');
          }
        }
        
        if (!canvas) {
          throw new Error('Chart canvas not accessible for printing');
        }
        
        const chartImageUrl = canvas.toDataURL('image/png', 1.0);
        
        // Prepare data for print table
        const printTableRows = this.state.tracking_hubs_report.map((hubData, index) => {
          return `<tr>
            <td style="text-align: center; font-weight: bold;">${hubData.name}</td>
            <td style="text-align: center;">${hubData.percentage_vist}%</td>
          </tr>`;
        }).join('');

        const printContent = `
          <html>
            <head>
              <title>Hub Visits Report - ${moment().format('DD/MM/YYYY')}</title>
              <style>
                @page {
                  margin: 0.5in;
                  size: portrait;
                }
                
                body { 
                  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; 
                  margin: 0;
                  padding: 20px;
                  background: white;
                  color: #333;
                  line-height: 1.4;
                }
                
                .print-container {
                  max-width: 100%;
                  margin: 0 auto;
                }
                
                .print-header { 
                  text-align: center; 
                  margin-bottom: 30px; 
                  border-bottom: 3px solid #1890ff;
                  padding-bottom: 20px;
                }
                
                .print-header h1 { 
                  color: #1890ff; 
                  margin-bottom: 10px;
                  font-size: 24px;
                  font-weight: bold;
                  text-transform: uppercase;
                }
                
                .chart-container {
                  text-align: center;
                  margin: 30px 0;
                }
                
                .chart-image {
                  max-width: 100%;
                  height: auto;
                  border: 1px solid #ddd;
                  border-radius: 8px;
                  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                }
                
                .data-table-container {
                  margin: 30px 0;
                }
                
                .data-table-title {
                  font-size: 18px;
                  font-weight: bold;
                  margin-bottom: 15px;
                  color: #1890ff;
                  text-align: center;
                }
                
                table { 
                  width: 100%; 
                  border-collapse: collapse; 
                  margin: 0 auto;
                  background: white;
                  font-size: 12px;
                }
                
                th { 
                  background: linear-gradient(135deg, #1890ff 0%, #0066cc 100%);
                  color: white;
                  font-weight: bold;
                  padding: 12px 8px;
                  text-align: center;
                  font-size: 12px;
                  text-transform: uppercase;
                  border: 1px solid #0066cc;
                }
                
                td { 
                  border: 1px solid #ddd; 
                  padding: 10px 8px; 
                  font-size: 11px;
                  vertical-align: middle;
                }
                
                tr:nth-child(even) { 
                  background-color: #f8f9fa; 
                }
                
                .print-footer { 
                  margin-top: 30px; 
                  text-align: center; 
                  font-size: 11px; 
                  color: #666;
                  border-top: 2px solid #1890ff;
                  padding-top: 15px;
                }
                
                .report-stats {
                  display: flex;
                  justify-content: space-around;
                  margin: 20px 0;
                  flex-wrap: wrap;
                }
                
                .stat-item {
                  text-align: center;
                  margin: 10px;
                  min-width: 150px;
                }
                
                .stat-value {
                  font-size: 18px;
                  font-weight: bold;
                  color: #1890ff;
                  display: block;
                }
                
                .stat-label {
                  font-size: 12px;
                  color: #666;
                  text-transform: uppercase;
                }
              </style>
            </head>
            <body>
              <div class="print-container">
                <div class="print-header">
                  <h1>Hub Visits Report</h1>
                  <p style="margin: 5px 0; font-size: 14px;">Generated on ${moment().format('MMMM DD, YYYY [at] HH:mm')}</p>
                  <div class="report-stats">
                    <div class="stat-item">
                      <span class="stat-value">${this.state.tracking_hubs_report.length}</span>
                      <span class="stat-label">Total Hubs</span>
                    </div>
                    <div class="stat-item">
                      <span class="stat-value">${this.state.tracking_hubs_report.reduce((sum, hub) => sum + parseFloat(hub.percentage_vist || 0), 0).toFixed(1)}%</span>
                      <span class="stat-label">Average Visit Rate</span>
                    </div>
                  </div>
                </div>
                
                <div class="chart-container">
                  <img src="${chartImageUrl}" alt="Hub Visits Chart" class="chart-image">
                </div>
                
                <div class="data-table-container">
                  <div class="data-table-title">Hub Visits Data</div>
                  <table>
                    <thead>
                      <tr>
                        <th>Hub Name</th>
                        <th>Visit Percentage</th>
                      </tr>
                    </thead>
                    <tbody>
                      ${printTableRows}
                    </tbody>
                  </table>
                </div>
                
                <div class="print-footer">
                  <p><strong>UMOJA Hub Visits Tracking System</strong></p>
                  <p>This report contains confidential delivery tracking information</p>
                  <p>Report generated automatically on ${moment().format('MMMM DD, YYYY [at] HH:mm')}</p>
                </div>
              </div>
            </body>
          </html>
        `;

        // Open print window
        const printWindow = window.open('', '_blank');
        printWindow.document.write(printContent);
        printWindow.document.close();
        
        // Wait for images to load before printing
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.print();
          }, 500);
        };
        
        message.success('Print preview opened successfully!');
      }
    } catch (error) {
      console.error('Print error:', error);
      message.error('Failed to print chart. Please try again.');
    }
  };


  componentDidMount(){
    // Check if tracking_hubs_report is provided via props, otherwise fetch it
    if (this.props.tracking_hubs_report) {
    this.setState({tracking_hubs_report:this.props.tracking_hubs_report})
    this.setState({datarequested:false})
    } else {
      // Fetch tracking data if not provided via props
      this.fetchTrackingData();
    }
    
    // Add resize listener for responsive behavior
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 768 });
  };

  componentDidUpdate() {
    this.drawValuesOnBars();
  }

  drawValuesOnBars = () => {
    if (this.chartRef.current) {
      const chart = this.chartRef.current.chartInstance;
      if (chart) {
        const ctx = chart.ctx;
        
        // Set text properties
        ctx.font = 'bold 14px Arial';
        ctx.fillStyle = '#000';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'bottom';
        
        // Draw text on top of each bar
        chart.data.datasets.forEach((dataset, datasetIndex) => {
          const meta = chart.getDatasetMeta(datasetIndex);
          meta.data.forEach((bar, index) => {
            const data = dataset.data[index];
            if (data && data > 0) {
              const x = bar._model ? bar._model.x : bar.x;
              const y = bar._model ? bar._model.y : bar.y;
              
              if (x && y) {
                ctx.fillText(data, x, y - 10);
              }
            }
          });
        });
      }
    }
  }


render() {


      if(this.state.datarequested===true){
        return(
          <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
                <Spin size="large">
                <div className="content">
                  <h3>Umoja Couriers</h3>
                </div>
                </Spin>        
          </div>
        )
      }else{

            const chartData = {
              labels:  this.state.tracking_hubs_report.map(item =>item.name),
              datasets: [
                {
                  label: 'Percentages',
                  data: this.state.tracking_hubs_report.map(item => item.percentage_vist),
                  backgroundColor: primarycolor,
                  borderColor: primarycolor,
                  borderWidth: 1,
                  borderRadius: 2,
                  categoryPercentage: 0.8,
                  barPercentage: 0.4,
                },
              ],
            };
        
            const options = {
              responsive: true,
              maintainAspectRatio: false,
                legend: {
                display: false,
                },
                title: {
                  display: true,
                  text: 'HUB VISITS',
                fontSize: 18,
                fontStyle: 'bold',
                padding: 40,

              },
              tooltips: {
                callbacks: {
                  label: function(tooltipItem, data) {
                    return tooltipItem.yLabel + '%';
                  }
                }
              },
              scales: {
                xAxes: [{
                  gridLines: {
                    display: false,
                  },
                  ticks: {
                    fontSize: 10,
                    maxRotation: 0,
                    minRotation: 0,
                    fontStyle: 'bold',
                    fontColor: '#333',
                    callback: function(value, index, values) {
                      // Truncate long labels to fit better
                      if (value.length > 12) {
                        return value.substring(0, 10) + '...';
                      }
                      return value;
                    }
                  }
                }],
                yAxes: [{
                  scaleLabel: {
                    display: true,
                    labelString: 'Percentage (%)',
                    fontSize: 12,
                    fontStyle: 'bold',
                    fontColor: '#666'
                  },
                  ticks: {
                  beginAtZero: true,
                    max: Math.max(...this.state.tracking_hubs_report.map(item => item.percentage_vist)) + 10,
                    display: false
                  },
                  gridLines: {
                    display: false,
                  }
                }],
              },
              animation: {
                duration: 1000,
                easing: 'easeInOutQuart',
                onComplete: function() {
                  const chart = this.chart;
                  const ctx = chart.ctx;
                  
                  // Set text properties
                  ctx.font = 'bold 14px Arial';
                  ctx.fillStyle = '#000';
                  ctx.textAlign = 'center';
                  ctx.textBaseline = 'bottom';
                  
                  // Draw text on top of each bar
                  chart.data.datasets.forEach(function(dataset, datasetIndex) {
                    const meta = chart.getDatasetMeta(datasetIndex);
                    meta.data.forEach(function(bar, index) {
                      const data = dataset.data[index];
                      if (data && data > 0) {
                        // Try different approaches to get bar position
                        let x = bar._model ? bar._model.x : bar.x;
                        let y = bar._model ? bar._model.y : bar.y;
                        
                        if (x && y) {
                          ctx.fillText(data, x, y - 10);
                        }
                      }
                    });
                  });
                }
              },
              layout: {
                padding: {
                  top: 40,
                  right: 20,
                  bottom: 30,
                  left: 20
                }
              }
            };


      return (
      <div className="animated fadeIn" style={{ 
        padding: '20px', 
        backgroundColor: '#f5f5f5',
        minHeight: '100vh'
      }}> 
        {/* Print Button */}
        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'flex-end' }}>
          <Button 
            type="primary" 
            icon={<PrinterOutlined />}
            style={{ backgroundColor: '#fa541c', borderColor: '#fa541c' }}
            onClick={this.printChart}
            size="large"
          >
            <span style={{ display: !this.state.isMobile ? 'inline' : 'none' }}>Print Chart</span>
          </Button>
        </div>


        {/* Chart Container */}
        <div style={{ 
          height: !this.state.isMobile ? '500px' : '400px', 
          width: '100%',
          overflow: 'auto',
          padding: '20px',
          backgroundColor: '#ffffff',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <Bar 
            ref={this.chartRef}
            data={chartData} 
            options={options}
            onElementsClick={() => {
              // Trigger redraw of values
              setTimeout(() => this.drawValuesOnBars(), 100);
            }}
          />
        </div>
      </div>
      );

    }
    
  
 

}
}

export default TrackingGraph; 
